// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eszc","colBig":"styles_colBig__1nkKy","colSmall":"styles_colSmall__1ol39","shopifyNameWrapper":"styles_shopifyNameWrapper__yNoIN"};